// extracted by mini-css-extract-plugin
export default {"root":"_1vsLlLAa","opacity":"_3l-LfrE-","pane":"_1B9KO0nB","reveal":"HrPCoha_","closeButton":"_1-aK0I6F"};